<template lang="pug">
  div
    hotel-date-picker(
      ref="datepicker"
      :first-day-of-week="1"
      :show-year="true"
      :lang="lang"
      format="DD/MM/YYYY"
      :start-date="startDate"
      :end-date="endDate"
      :initial-check-in="initialCheckIn"
      :initial-check-out="initialCheckOut"
      @check-in-changed="updateCheckIn"
      @check-out-changed="updateCheckOut"
      :current-date-style='{border: "2px solid #bba640"}'
      :display-clear-button="displayClearButton"
      :hovering-tooltip="hoveringTooltip"
      :disable-dates-without-price="disableDatesWithoutPrice"
      :disabled-dates="disabledDates"
      :price-by-date="priceByDate"
      :min-nights-by-date="minNightsByDate"
    )
</template>

<script>
import dayjs from 'dayjs'
import EventBus from '@utils/event-bus'
import HotelDatePicker from 'vue-hotel-datepicker'

export default {
  components: {
    HotelDatePicker
  },

  props: {
    startDate: {
      type: [Date, String],
      default: () => new Date()
    },

    endDate: {
      type: [Date, String],
      default: undefined
    },

    initialCheckIn: {
      type: String,
      default: ''
    },

    initialCheckOut: {
      type: String,
      default: ''
    },

    displayClearButton: {
      type: Boolean,
      default: true
    },

    hoveringTooltip: {
      type: Boolean,
      default: true
    },

    disableDatesWithoutPrice: {
      type: Boolean,
      default: false
    },

    lang: {
      type: String,
      required: true
    },

    disabledDates: {
      type: Array,
      default: () => []
    },

    priceByDate: {
      type: Array,
      default: () => []
    },

    minNightsByDate: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      checkIn: this.initialCheckIn,
      checkOut: this.initialCheckOut
    }
  },

  mounted () {
    this.$watch("$refs.datepicker.isOpen", (newValue, _oldValue) => {
      document.body.classList.toggle("datepicker--is-open", newValue)
    })
  },

  methods: {
    updateCheckIn (date) {
      this.checkIn = date ? dayjs(date).format('YYYY-MM-DD') : null

      document.cookie = "checkin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      document.cookie = 'checkin=' + this.checkIn + '; expires=' + dayjs(new Date()).add(1, 'hour').format('ddd, DD MMM YYYY HH:mm:ss UTC') + '; path=/;'
    },

    updateCheckOut (date) {
      this.checkOut = date ? dayjs(date).format('YYYY-MM-DD') : null

      document.cookie = "checkout=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
      document.cookie = 'checkout=' + this.checkOut + '; expires=' + dayjs(new Date()).add(1, 'hour').format('ddd, DD MMM YYYY HH:mm:ss UTC') + '; path=/'

      // emit both a custom event and an event on the global event bus
      const eventValue = { checkIn: this.checkIn, checkOut: this.checkOut }
      this.$emit('change', eventValue)
      EventBus.$emit('reservation-dates-changed', eventValue)
    }
  }
}
</script>
